import { api } from '@here/api'
import { ListTypes, type Pagination } from '..'

export const handleGetMine = async (
	listType: ListTypes,
	userId?: string,
	pagination?: Pagination,
) => {
	if (listType !== ListTypes.mine || !userId || !pagination) {
		return []
	}

	let query = api()
		.from('setup')
		.select('*')
		.eq('created_by', userId)

	// Apply limit + offset
	if (pagination.limit !== undefined && pagination.offset !== undefined) {
		query = query.range(pagination.offset, pagination.offset + pagination.limit - 1)
	}

	const { data } = await query
	return data || []
}
